import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  triggerSave: false,
};

const communicationSlice = createSlice({
  name: "communication",
  initialState,
  reducers: {
    callSaveFunction(state, action) {
      // Store SuperTrack ID instead of just a boolean value - true
      state.triggerSave = action.payload;
    },
    resetSaveFunction(state) {
      state.triggerSave = false;
    },
  },
});

export const { callSaveFunction, resetSaveFunction } =
  communicationSlice.actions;
export default communicationSlice.reducer;
